import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="font-sans text-gray-800 bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <AboutSection data-id="element-5" />
        <TestimonialsSection data-id="element-6" />
        <ContactSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
      <WhatsAppButton data-id="element-9" />
    </div>;
}